import { createAction, props } from "@ngrx/store";
import { City } from "../../models/cities.model";

export const getCities = createAction(
    '[Cities] Get Cities',
);

export const getCitiesSuccess = createAction(
    '[Cities] Get Cities Success',
    props<{ cities: City[] }>()
);

export const getCitiesFailure = createAction(
    '[Cities] Get Cities Failure',
    props<{ error: any }>()
);

export const setUserSelectedCity = createAction(
    '[Cities] User Selected City',
    props<{ city: City }>()
);

export const setUserSelectedCitySuccess = createAction(
    '[Cities] Select City Success',
    props<{ city: City }>()
);

export const setUserSelectedCityFailure = createAction(
    '[Cities] Select City Failure',
    props<{ error: any }>()
);

export const setUserSelectedCityId = createAction(
    '[Cities] User Selected City Id',
    props<{ city_id: number }>()
);

export const setUserSelectedCityIdSuccess = createAction(
    '[Cities] Select City Id Success',
    props<{ city_id: number }>()
);

export const setUserSelectedCityIdFailure = createAction(
    '[Cities] Select City Id Failure',
    props<{ error: any }>()
);